import constants from "../constants";

/**
 * Reducer for availability. Null fetching allows for 3 states.
 */
function availability(state = {
  startDate: null,
  endDate: null,
  numNights: null,
  list: [],
  fetching: null,
  showPrices: null,
}, action) {
  switch (action.type) {
    case constants.LAYOUT_MOBILE: {
      // if user is on desktop and hasn't selected dates
      // we want to show the datePicker
      return {
        ...state,
        showPrices: !state.startDate && !action.data,
      };
    }
    case constants.SELECT_DATES: {
      return {
        startDate: action.data.startDate,
        endDate: action.data.endDate,
        numNights: action.data.numNights,
        list: [...state.list],
        fetching: null,
        showPrices: state.showPrices,
      };
    }
    case constants.AVAILABILITY_ERROR: {
      return {
        startDate: null,
        endDate: null,
        numNights: null,
        list: [],
        fetching: null,
        showPrices: null,
      };
    }
    case constants.POI_UNMOUNT: {
      return {
        startDate: state.startDate,
        endDate: state.endDate,
        numNights: state.numNights,
        list: [],
        fetching: null,
        showPrices: state.showPrices,
      };
    }
    case constants.FILTER_LIST:
    case constants.FETCH_AVAILABILITY: {
      let { startDate, endDate, numNights } = state;

      if (action.data.filters && action.data.filters.booking) {
        startDate = action.data.filters.booking.dates.startDate;
        endDate = action.data.filters.booking.dates.endDate;
        numNights = action.data.filters.booking.dates.numNights;
      } else if (action.data.startDate && action.data.endDate) {
        startDate = action.data.startDate;
        endDate = action.data.endDate;
        numNights = action.data.numNights;
      }

      return {
        startDate,
        endDate,
        numNights,
        list: [...state.list],
        fetching: true,
        showPrices: state.showPrices,
      };
    }
    case constants.FILTER_LIST_DONE:
    case constants.FETCH_AVAILABILITY_DONE: {
      return {
        startDate: state.startDate,
        endDate: state.endDate,
        numNights: state.numNights,
        list: [...action.data],
        fetching: false,
        showPrices: state.showPrices,
      };
    }
    case constants.SHOW_PRICES: {
      return {
        startDate: state.startDate,
        endDate: state.endDate,
        numNights: state.numNights,
        list: [...state.list],
        fetching: false,
        showPrices: action.data,
      };
    }
    default: {
      return state;
    }
  }
}

export default availability;



// WEBPACK FOOTER //
// ./assets/shared/reducers/availability.js